import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "./api.gateway";

export const fetchAllInterviewByCampaignId = async (campaignId, filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await axiosGet(`/interview?campaign_id=${campaignId}&${queryParams}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const fetchAllInterview = async () => {
  try {
    const response = await axiosGet(`/interview`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const fetchInterviewByUUID = async (uuid) => {
  try {
    const response = await axiosGet(`/interview/${uuid}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const createInterview = async (data) => {
  try {
    const response = await axiosPost(`/interview/create`, data);
    return response;
  } catch (error) {
    throw error;
  }
}

export const updateInterview = async (uuid, data) => {
  try {
    const response = await axiosPatch(`/interview/edit/${uuid}`, data);
    return response;
  } catch (error) {
    throw error;
  }
}

export const deleteInterview = async (uuid, data) => {
  try {
    const response = await axiosDelete(`/interview/delete/${uuid}`);
    return response;
  } catch (error) {
    throw error;
  }
}